export default __webpack_public_path__ + "static/media/kaushik-mody.d418505b.jpg";